import { useMemo } from 'react';
import { useNarrativeSyntheticValuationOptions } from '../hooks/useNarrativeSyntheticValuationOptions';
import { NarrativeCardCompactSyntheticPopulated } from './NarrativeCardCompactSyntheticPopulated';
import { NarrativeInvalidationBoundary } from '../../NarrativeInvalidationBoundary';

type Props = {
  canonicalUrl: string;
  type: 'DCF' | 'ANALYSTS';
};

export const NarrativeCardCompactSyntheticMain = ({
  canonicalUrl,
  type,
}: Props) => {
  const { data } = useNarrativeSyntheticValuationOptions({ canonicalUrl });
  const valuationOption = useMemo(() => {
    return data.Company.valuationOptions.find(
      (valuationOption) => valuationOption.type === type
    );
  }, [data.Company, type]);

  if (!valuationOption) return null;

  return (
    <NarrativeInvalidationBoundary
      onSetPrimary={({ invalidatePriority }) =>
        invalidatePriority(['narrative-synthetic-valuation-options'])
      }
    >
      <NarrativeCardCompactSyntheticPopulated
        valuationOption={valuationOption}
      />
    </NarrativeInvalidationBoundary>
  );
};
